
















import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import TipJarIntegration from '@/web/components/settings/TipJarIntegration.vue';

export default Vue.extend({
  name: 'TipJar',
  components: { TopNav, TipJarIntegration },
});
